import React from 'react';

type PhoneSize = 'sm' | 'md' | 'lg';
type PhoneSurface = 'ink' | 'cream';

type Props = {
  src: string;
  alt: string;
  /** sm = 200px (inside cards), md = 270px, lg = 310px (hero centre). */
  size?: PhoneSize;
  /** Which background the phone sits on; changes the bezel and shadow. */
  surface?: PhoneSurface;
  className?: string;
  eager?: boolean;
};

/**
 * A phone bezel around an app screenshot. The image keeps the iPhone
 * 1179x2556 aspect ratio and is never cropped by the frame.
 */
const PhoneFrame = ({ src, alt, size = 'md', surface = 'ink', className = '', eager = false }: Props) => (
  <div className={['bh-phone', `bh-phone--${size}`, `bh-phone--${surface}`, className].filter(Boolean).join(' ')}>
    <img
      src={src}
      alt={alt}
      width={1179}
      height={2556}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
    />
  </div>
);

export default PhoneFrame;
